var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStreamerLive = function SvgStreamerLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M19.03 15.228c-.25.345-.387.768-.387 1.234v9.689c0 .863.47 1.69 1.255 2.214.401.266.841.425 1.273.475.415.048.822-.003 1.178-.158l9.96-3.715c.361-.157.656-.393.868-.687l-1.654 2.346c-.212.293-.507.53-.868.687l-9.96 3.715a2.3 2.3 0 0 1-1.178.158 2.9 2.9 0 0 1-1.272-.475c-.786-.524-1.256-1.35-1.256-2.214v-9.689c0-.466.137-.89.387-1.234z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E0F5",
    d: "M32.309 20.834c-.058-.04-9.836-5.96-9.9-6-.787-.524-1.725-.632-2.51-.293-.786.34-1.256 1.058-1.256 1.921v9.689c0 .863.47 1.69 1.255 2.214.401.266.841.425 1.273.475.415.048.822-.003 1.178-.158l9.96-3.715c.785-.34 1.254-1.058 1.254-1.92s-.469-1.689-1.254-2.213"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M36.88 11.106c-.348.488-.28 1.202.204 1.718 3.263 3.481 5.06 7.82 5.06 12.218 0 3.078-.881 5.922-2.528 8.285l-1.654 2.346c1.647-2.363 2.527-5.207 2.527-8.285 0-4.397-1.796-8.737-5.059-12.218-.484-.517-.552-1.23-.203-1.719z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M39.615 33.327a14 14 0 0 1-2.531 2.753 1.2 1.2 0 0 0-.204.218l-1.653 2.346q.084-.12.203-.218a14 14 0 0 0 2.532-2.753z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M36.88 36.298c-.348.489-.28 1.203.204 1.72.282.3.65.477 1.02.52.368.043.737-.048 1.019-.283a16.4 16.4 0 0 0 2.787-2.976l-1.653 2.346a16.4 16.4 0 0 1-2.788 2.976c-.281.235-.65.326-1.02.283a1.67 1.67 0 0 1-1.019-.52c-.484-.518-.552-1.231-.203-1.72z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M32.739 14.56c-.349.488-.28 1.201.203 1.718 3.749 4 4.349 9.508 1.8 13.374l-1.654 2.345c2.549-3.865 1.949-9.373-1.8-13.373-.484-.517-.552-1.23-.203-1.719z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M34.742 29.652a9.2 9.2 0 0 1-1.8 2.008 1.2 1.2 0 0 0-.203.218l-1.654 2.346q.086-.12.204-.218a9.2 9.2 0 0 0 1.8-2.009z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M32.739 31.878c-.349.489-.28 1.203.203 1.72.282.3.651.477 1.02.52s.738-.048 1.02-.283c.756-.63 1.417-1.34 1.978-2.113l-1.654 2.346a11.6 11.6 0 0 1-1.978 2.113c-.282.235-.651.326-1.02.283a1.67 1.67 0 0 1-1.02-.52c-.484-.518-.552-1.231-.203-1.72z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M12.8 9.75c.348-.489.28-1.202-.204-1.72-.563-.6-1.476-.707-2.039-.237a16.4 16.4 0 0 0-2.787 2.976l-1.654 2.346a16.4 16.4 0 0 1 2.787-2.976c.563-.47 1.476-.363 2.04.238.484.516.551 1.23.203 1.718z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M7.77 10.77c-2.03 2.801-3.116 6.207-3.116 9.9 0 5.129 2.096 10.192 5.903 14.253.282.301.65.478 1.02.52.369.044.738-.047 1.02-.282q.117-.099.203-.218l-1.654 2.346a1.2 1.2 0 0 1-.204.218c-.281.235-.65.326-1.02.283a1.67 1.67 0 0 1-1.019-.52C5.097 33.207 3 28.144 3 23.015c0-3.694 1.087-7.099 3.116-9.9z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M9.876 13.004a14 14 0 0 1 2.72-3.036q.119-.098.204-.218l-1.654 2.345q-.085.12-.204.22c-1.08.9-1.986 1.922-2.72 3.035z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M12.721 14.326c-1.44 1.988-2.212 4.405-2.212 7.027 0 3.64 1.488 7.233 4.191 10.117.282.3.65.477 1.02.52.368.043.737-.048 1.019-.282q.119-.1.203-.22l-1.653 2.347q-.085.12-.204.218c-.282.235-.65.326-1.02.283a1.67 1.67 0 0 1-1.019-.52c-2.703-2.884-4.191-6.476-4.191-10.118 0-2.621.772-5.038 2.213-7.026z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_7551_12292)",
    fillRule: "evenodd",
    d: "M15.065 16.209a9.3 9.3 0 0 1 1.674-1.82q.119-.1.203-.22l-1.653 2.347q-.085.12-.204.218a9.3 9.3 0 0 0-1.674 1.82z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_7551_12292)",
    d: "M39.123 11.125c-.564-.601-1.476-.708-2.04-.238-.562.47-.562 1.336 0 1.937 3.263 3.481 5.06 7.82 5.06 12.218s-1.797 8.317-5.06 11.038c-.562.47-.562 1.336 0 1.937.282.3.651.478 1.02.52.37.044.738-.047 1.02-.282 3.807-3.173 5.904-7.746 5.904-12.877 0-5.13-2.097-10.192-5.904-14.253m-4.142 3.454c-.563-.602-1.475-.708-2.039-.238-.563.47-.563 1.336 0 1.937 4.463 4.762 4.463 11.661 0 15.382-.563.47-.563 1.336 0 1.937.282.3.651.478 1.02.52.369.044.738-.047 1.02-.282 2.702-2.253 4.19-5.498 4.19-9.14 0-3.64-1.488-7.233-4.19-10.116m-22.385-4.61c.563-.47.563-1.337 0-1.938s-1.476-.708-2.039-.238C6.75 10.966 4.654 15.54 4.654 20.67c0 5.129 2.096 10.192 5.903 14.254.282.3.65.477 1.02.52.369.043.738-.048 1.02-.283.562-.47.562-1.336 0-1.937-6.747-7.198-6.747-17.631 0-23.256m4.143 2.482c-.563-.601-1.476-.708-2.04-.238-2.702 2.253-4.19 5.498-4.19 9.14 0 3.64 1.488 7.233 4.19 10.117.283.3.651.477 1.02.52.37.043.738-.048 1.02-.282.563-.47.563-1.337 0-1.938-2.158-2.302-3.347-5.172-3.347-8.081 0-2.91 1.189-5.502 3.347-7.3.563-.47.563-1.337 0-1.938"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7551_12292",
    x1: 28.393,
    x2: 21.012,
    y1: 10.779,
    y2: 28.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7551_12292",
    x1: 40.035,
    x2: 25.544,
    y1: 4.264,
    y2: 13.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7551_12292",
    x1: 39.871,
    x2: 37.62,
    y1: 33.715,
    y2: 40.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7551_12292",
    x1: 34.687,
    x2: 24.151,
    y1: 9.703,
    y2: 17.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7551_12292",
    x1: 35.159,
    x2: 33.317,
    y1: 30.399,
    y2: 35.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7551_12292",
    x1: 9.904,
    x2: -7.069,
    y1: 3.241,
    y2: 17.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7551_12292",
    x1: 11.447,
    x2: 8.485,
    y1: 8.19,
    y2: 13.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7551_12292",
    x1: 14.553,
    x2: 1.809,
    y1: 8.75,
    y2: 20.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7551_12292",
    x1: 15.899,
    x2: 13.561,
    y1: 12.949,
    y2: 17.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7551_12292",
    x1: 29.625,
    x2: 11.25,
    y1: -1.125,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A0526"
  })))));
};
export default SvgStreamerLive;